export default __webpack_public_path__ + "static/media/banner-ielts.58c05d31.jpg";